import { useRecoilValue, useSetRecoilState } from 'recoil'
import { postInquiry, postInquiryImage } from '../api/inquiries'
import { filesState, inquiryState, isInViewFooterState, onetimeKeyState } from '../states/messageState'
import { useSendMessage } from './useSendMessage'

export const useSubmitInquiry = () => {
  const { handleAddSenderParent, handleAddMessage } = useSendMessage()
  const inquiry = useRecoilValue(inquiryState)
  const files = useRecoilValue(filesState)
  const onetimeKey = useRecoilValue(onetimeKeyState)
  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)

  //保証申請実行ハンドラー
  const handleSubmitInquiry = async () => {
    setIsInViewFooter(false)
    await handleAddSenderParent(
      'bot',
      `こちらの内容で保証申請致します。\n時期: ${inquiry?.failureDate}\n内容: ${inquiry.description}`
    )
    const inquiryRes = await postInquiry(inquiry, onetimeKey)
    for (const file of files) {
      await postInquiryImage(inquiryRes.id, onetimeKey, file)
    }
    const message = '申請ありがとうございました。素敵な一日をお過ごしください。'
    handleAddMessage('bot', message)
  }

  return { handleSubmitInquiry }
}
